import { Outlet } from "react-router-dom";
import { SubNavLink } from "../components/SubNavLink";
import useQueryParams from "../lib/useQueryParams";
import { applySearchParams } from "../lib/urlForView";
import classNames from "classnames";

export default function SummaryPage() {
  const params = useQueryParams();

  return (
    <div
      data-testid="summary"
      className={classNames("flex-auto min-w-0 flex flex-col bg-slate-100 rounded-b-md", {
        "bg-slate-100": Features.BetterBuildsUIGA,
        "bg-white": !Features.BetterBuildsUIGA,
      })}
    >
      <nav className="flex px-2.5 pb-1.5 pt-2 border-b border-b-gray-400 shadow-sm z-20">
        <div className="flex gap-2">
          {Features.BetterBuildsUIGA && (
            <SubNavLink to={applySearchParams(".", params)} end={true}>
              Overview
            </SubNavLink>
          )}
          {!Features.BetterBuildsUIGA && <SubNavLink to="./annotations">Annotations</SubNavLink>}
          <SubNavLink to={applySearchParams("./step-uploads", params)}>Step uploads</SubNavLink>
        </div>
      </nav>

      <div className="flex-auto min-w-0 flex flex-col relative">
        <div className="flex w-full h-full absolute overflow-y-auto">
          <div className="w-full flex flex-col gap-2 relative">
            <div className="flex-1 p-3">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
